import axios from "axios";
import appConfig from "../config/app.config";

const makePostRequest = async (url, data, headers = {}) => {
  const config = {
    method: "post",
    url,
    data,
    headers,
  };
  const response = await axios(config);
  return response;
};

const makeGetRequest = async (url) => {
  let config = {
    method: "get",
    url
  };
  const response = await axios(config);
  return response;
};

const makePutRequest = async (url, data) => {
  const config = {
    method: "put",
    url,
    data,
  };
  const response = await axios(config);
  return response;
};

const makeDeleteRequest = async (url, headers={}) => {
  let config = {
    method: "delete",
    url,
    headers
  };
  const response = await axios(config);
  return response;
};
export { makeGetRequest, makePostRequest, makePutRequest , makeDeleteRequest};
